import html2canvas from 'html2canvas';

import { Injectable } from '@angular/core';

import { FsMap } from '@lib/geo/map';

import { GoogleMap } from '../map';

@Injectable()
export class FsGoogleMapScreenshotService {
  constructor() {}

  public screenshotMap(map: FsMap | GoogleMap): Promise<HTMLCanvasElement> {
    return html2canvas(map.getContainer(), {
      useCORS: true,
      allowTaint: true,
      height: map.getContainer().clientHeight,
      width: map.getContainer().clientWidth,
      scale: 1,
      x: map.getContainer().clientLeft,
      y: map.getContainer().clientTop,
    });
  }
}
